/**
 * AI Video Ads retires on 2026-09-22 (ENG-1047). The Sora 2 Pro service the generator depends on is
 * sunsetting, so past that date the feature breaks rather than degrading -- better to withdraw it
 * on our own terms than to let submissions fail.
 *
 * The cutoff is 07:00 UTC, i.e. midnight Pacific, so the feature disappears on the 22nd in every US
 * timezone instead of on the evening of the 21st for most of them.
 *
 * This is a client-clock check: a device with a badly wrong clock can still reach the form. That is
 * accepted -- the upstream service being gone is the real enforcement, and no frontend-only check
 * can close that gap. Gating the webhook in core-api would, if we ever decide it is worth it.
 */
export const VIDEO_ADS_SUNSET_AT = new Date('2026-09-22T07:00:00Z');

export const isVideoAdsRetired = (now: Date = new Date()): boolean => now >= VIDEO_ADS_SUNSET_AT;
